export function LoadingScreen({ label = "Chargement..." }: { label?: string }) {
  return (
    <div className="shell center-screen">
      <div className="loading-card">
        <div className="spinner" />
        <p>{label}</p>
      </div>
    </div>
  );
}

export function LoadingCard({ label = "Chargement..." }: { label?: string }) {
  return (
    <div className="card loading-card">
      <div className="spinner" />
      <p>{label}</p>
    </div>
  );
}

export function ErrorScreen({ message = "Une erreur est survenue" }: { message?: string }) {
  return (
    <div className="shell center-screen">
      <div className="card error-card">
        <h2>Erreur</h2>
        <p>{message}</p>
      </div>
    </div>
  );
}

export function ErrorCard({ message = "Une erreur est survenue" }: { message?: string }) {
  return (
    <div className="card error-card">
      <h3>Erreur</h3>
      <p>{message}</p>
    </div>
  );
}